import React, { useEffect } from "react"
import { Link as RouterLink } from "react-router-dom"
import { providerFinderRootPath } from "../../utils/providerFinderSearchUrl"
import { getHeap } from "../../utils/heap"
import { FormattedMessage } from "react-intl"
import { Box, Button, Link, Typography } from "@carrotfertility/carotene-core"
import { NoResultLayout } from "./NoResultLayout"
import useGetUserInfoConditionsSubset from "#/services/user/hooks/useGetCurrentUserConditionsSubset"
import { Journey } from "#/components/carrot-plans/types/journey"

const SPECIALIST_BASE_URL = "/talk-to-carrot/united-states-of-america/specialist"
const PELVIC_HEALTH_SUPPORT_SUFFIX = "pelvic-health-support"

const pelvicHealthSupportSpecialtyByJourney: Partial<Record<Journey, string>> = {
  [Journey.PREGNANT]: "Pregnancy",
  [Journey.PARENTING]: "Parenting",
  [Journey.MENOPAUSE]: "menopause",
  [Journey.GENDER_AFFIRMING_CARE]: "gender-affirming-care",
  [Journey.TRY_PREGNANT]: "fertility"
}

function getPelvicHealthSupportUrl(memberActiveJourney: string): string {
  const specialty = pelvicHealthSupportSpecialtyByJourney[memberActiveJourney as Journey]
  return specialty ? `${SPECIALIST_BASE_URL}/${specialty}/${PELVIC_HEALTH_SUPPORT_SUFFIX}` : SPECIALIST_BASE_URL
}

export function PelvicHealthNoResultDisplay({
  isCountryCodeMatching
}: {
  isCountryCodeMatching: boolean
}): JSX.Element {
  const { data: userInfo } = useGetUserInfoConditionsSubset()
  const expertChatUrl = getPelvicHealthSupportUrl(userInfo?.memberActiveJourney ?? "")

  useEffect(
    function trackPelvicHealthSearchNoResultsMessageRendered() {
      getHeap().track("Pelvic Health Search No Results Message Rendered", {
        "Location Is Outside Country": !isCountryCodeMatching ? "true" : "false"
      })
    },
    [isCountryCodeMatching]
  )

  return (
    <NoResultLayout
      header={
        <Typography variant="h4" color="secondary">
          <FormattedMessage defaultMessage="No results in Provider finder, but..." />
        </Typography>
      }
      body={
        <Typography variant="body1" color="secondary">
          <FormattedMessage
            defaultMessage="We have other ways to support you, such as a <expertChatLink>medical expert chat with a pelvic health specialist</expertChatLink> and <academyLink>Carrot Academy resources</academyLink>."
            values={{
              expertChatLink: (linkContent) => (
                <Link component={RouterLink} color="inherit" to={expertChatUrl}>
                  {linkContent}
                </Link>
              ),
              academyLink: (linkContent) => (
                <Link component={RouterLink} color="inherit" to="/read/Fertility/why-pelvic-floor-health-matters">
                  {linkContent}
                </Link>
              )
            }}
          />
        </Typography>
      }
      actions={
        <Box display="flex" gap={(theme) => theme.tokens.spacing.xs}>
          <Button component={RouterLink} to={providerFinderRootPath} variant="outlined" color="secondary" size="medium">
            <FormattedMessage defaultMessage="Search again" />
          </Button>
        </Box>
      }
    />
  )
}
